import React from "react";
import { Body, Main, AccountDatePicker } from "./styles"
import moment from 'moment';

export default props => {
    return (
        <Body style={props.style}>
            <Main>
                <label>{props.labelText}</label>
                <AccountDatePicker
                    onChange={props.onChange}
                    value={props.value || ""}
                    format={props.format}
                    bordered={false}
                    placeholder={props.placeholder}
                    disabled={props.disabled}/>
            </Main>
        </Body>
    )
}